import React from 'react';
import { AlertCircle, HelpCircle } from 'lucide-react';

/**
 * Anzeige unter einem E-Mail-Feld: Tippfehler-Vorschlag (1-Klick-Übernahme) oder Ungültig-Meldung.
 * check = Ergebnis von useEmailCheck; onAccept(correctedEmail) übernimmt den Vorschlag.
 */
export const EmailCheckHint = ({ check, onAccept }) => {
  if (!check) return null;
  if (check.status === 'typo' && check.suggestion) {
    return (
      <div className="mt-1.5 flex items-center gap-2 text-sm bg-amber-50 border border-amber-200 rounded-lg px-3 py-2" data-testid="email-typo-hint">
        <HelpCircle className="w-4 h-4 text-amber-600 shrink-0" />
        <span className="text-amber-800">
          Meintest du{' '}
          <button type="button" onClick={() => onAccept?.(check.suggestion)} data-testid="email-suggestion-btn"
            className="font-bold underline underline-offset-2 hover:text-amber-950">
            {check.suggestion}
          </button>
          ?
        </span>
      </div>
    );
  }
  if (check.status === 'invalid') {
    return (
      <div className="mt-1.5 flex items-start gap-2 text-sm bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="email-invalid-hint">
        <AlertCircle className="w-4 h-4 text-red-600 shrink-0 mt-0.5" />
        <span className="text-red-700">
          {check.message || 'Diese E-Mail-Adresse scheint nicht zu existieren. Bitte prüfe sie – sonst bekommst du keine Bestellbestätigung und keine Status-Updates.'}
          {check.suggestion && (
            <>
              {' '}Meintest du{' '}
              <button type="button" onClick={() => onAccept?.(check.suggestion)} data-testid="email-suggestion-btn"
                className="font-bold underline underline-offset-2">
                {check.suggestion}
              </button>
              ?
            </>
          )}
        </span>
      </div>
    );
  }
  return null;
};
